import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Icons from "components/CustomIcons";
import AnalyticsTable from "./AnalyticsTable";
import AnalyticsChart from "./AnalyticsChart";
import helpers from "../AnalyticsHelpers";

function AnalyticsResults({
  title,
  points,
  queryPeriod,
  allApartments,
  projectTimeZone,
  measurement,
  field,
  metricsConfig,
  darkMode,
  onRemove,
  t,
}) {
  const isPresence = measurement === "presence";
  const isTableOnly = allApartments;
  const [selectedType, setSelectedType] = useState(isTableOnly ? "table" : "chart");
  const hasData = !!points?.length;

  return (
    <MDBox
      style={{
        marginTop: 16,
        borderRadius: 12,
        padding: 10,
        border: darkMode ? "1px solid #26304b" : "1px solid #e5e7eb",
        background: darkMode ? "#26304b" : "#ffffff",
        width: "100%",
        position: "relative",
      }}
    >
      {/* Header con título y botones */}
      <MDBox
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 8,
          marginBottom: 4,
        }}
      >
        {/* Título del gráfico */}
        <MDBox style={{ minWidth: 0 }}>
          {title && (
            <MDBox
              style={{
                fontWeight: 700,
                fontSize: 18,
                color: darkMode ? "#f8fafc" : "#0f172a",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={title}
            >
              {title}
            </MDBox>
          )}
        </MDBox>
        {/* Botones de selección de vista, descarga y eliminación */}
        <Grid display="flex" flexDirection="row">
          {hasData && !isTableOnly && (
            <MDBox onClick={() => setSelectedType("chart")}>
              <Icons name="Chart" size={30} color={darkMode ? "white" : "grey"} />
            </MDBox>
          )}
          {hasData && (
            <MDBox onClick={() => setSelectedType("table")} style={{ marginLeft: 16 }}>
              <Icons name="List" size={30} color={darkMode ? "white" : "grey"} />
            </MDBox>
          )}
          {hasData && (
            <MDBox
              style={{ marginLeft: 16, marginRight: 16 }}
              onClick={() => {
                helpers.handleDownload({
                  points,
                  title,
                  isPresence,
                  measurement,
                  field,
                  queryPeriod,
                  projectTimeZone,
                  t,
                });
              }}
            >
              <Icons name="Download" size={30} color={darkMode ? "white" : "grey"} />
            </MDBox>
          )}
          <MDButton color="info" variant="gradient" size="medium" onClick={onRemove}>
            {t("Delete")}
          </MDButton>
        </Grid>
      </MDBox>
      {/* Si no hay datos, mostrar mensaje */}
      {!hasData && (
        <MDBox
          style={{
            marginTop: 10,
            marginBottom: 6,
            padding: 12,
            borderRadius: 8,
            border: darkMode ? "1px dashed #475569" : "1px dashed #cbd5e1",
            color: darkMode ? "#cbd5e1" : "#475569",
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          {t("noPossibleShowData")}
        </MDBox>
      )}
      {hasData && (isTableOnly || selectedType === "table") && (
        <AnalyticsTable
          points={points}
          allApartments={allApartments}
          queryPeriod={queryPeriod}
          measurement={measurement}
          field={field}
          projectTimeZone={projectTimeZone}
          metricsConfig={metricsConfig}
          t={t}
        />
      )}
      {hasData && !isTableOnly && selectedType === "chart" && (
        <AnalyticsChart
          points={points}
          queryPeriod={queryPeriod}
          measurement={measurement}
          field={field}
          metricsConfig={metricsConfig}
          darkMode={darkMode}
          t={t}
        />
      )}
    </MDBox>
  );
}

AnalyticsResults.propTypes = {
  title: PropTypes.string,
  points: PropTypes.array.isRequired,
  allApartments: PropTypes.bool.isRequired,
  queryPeriod: PropTypes.string.isRequired,
  onRemove: PropTypes.func,
  darkMode: PropTypes.bool,
  measurement: PropTypes.string,
  field: PropTypes.string,
  projectTimeZone: PropTypes.string,
  metricsConfig: PropTypes.object,
  t: PropTypes.func,
};

AnalyticsResults.defaultProps = {
  title: "",
  onRemove: undefined,
  darkMode: false,
  measurement: "",
  field: "",
  projectTimeZone: "UTC",
  metricsConfig: {},
  t: () => {},
};

export default AnalyticsResults;
